<template>
	<v-layout>
		<v-flex xs12>
			<v-container v-bind="{ [`grid-list-sm`]: true }" fluid>
				<v-layout row wrap>
					<v-flex
						v-for="item in filterProducts(group.products)"
						:key="item.id"
						xs6
					>
						<div class="sub-product-wrapper">
							<div @click="changeSelection(item.id)" class="sub-product-content">
								<v-card flat tile>
									<img width="116px" height="67px" :src="backImg(item)[0]"/>
								</v-card>
								<div class="subproduct-name"> {{item.name | translate(`product.${item.id}.name`)}}</div>
								<div :class="{'checked-text' : item.id===selectedSubproducts}" data-cy="item-price">{{
									getSubproductPrice(item) }}
								</div>
							</div>
							<v-checkbox class="subproduct-checkbox"
										:key="item.id"
										:value="item.id"
										v-model="selectedSubproducts"
										hide-details
							>
							</v-checkbox>
						</div>
					</v-flex>
				</v-layout>
			</v-container>
		</v-flex>
	</v-layout>
</template>

<script>
	import * as Utils from "../../../../../libraries/utils";
	import {formatPrice} from "../../../../../domains2/libraries/Utils";
	import appConfig, {channelEnum} from "../../../../../appconfig";
	import {canBePickedUp} from "../../../../../libraries/utils";
	import {mapGetters} from "vuex";

	export default {
		name: "CheckboxGroup-gt3",
		props: ["group", "changeGroupProductSelection", "productSelection", "isSingleMenuPage"],
		data() {
			const self = this;
			return {
				selectedSubproducts: (() => {
					const selectedProductGroup = self.productSelection.groups.find(group => group.groupId === self.group.id);
					if (selectedProductGroup) {
						if (selectedProductGroup.selectedProducts && selectedProductGroup.selectedProducts.length > 0) {
							return selectedProductGroup.selectedProducts;
						} else {
							return [];
						}
					} else {
						return [];
					}
				})()
			};
		},
		computed: {
			...mapGetters([
				"globalSelectedShop",
				"productCatalog"
			]),
			staticPath() {
				return Utils.getStaticPath();
			},
			isKioskChannel() {
				return appConfig.channelAlias() === channelEnum.kiosk;
			}
		},
		methods: {
			filterProducts(products) {
				return products.filter(product => {
					return canBePickedUp(
						product,
						this.productCatalog,
						this.$store.getters.cachedPickupRules,
						this.globalSelectedShop.id
					);
				});
			},
			getSubproductPrice(product) {
				const self = this;
				const price = isNaN(parseInt(product.getPriceInGroup())) ? 0 : parseInt(product.getPriceInGroup());
				const formattedPrice = formatPrice(price);
				return self.group.options.customPriceLabel ? `${formattedPrice} ${self.group.options.customPriceLabel}` : formattedPrice;
			},
			backImg(product) {
				return Utils.getBackImages(product, this.isKioskChannel);
			},
			changeSelection(productId) {
				const self = this;
				const index = self.selectedSubproducts.findIndex(val => val === productId);
				if(index !== -1) {
					self.selectedSubproducts.splice(index, 1);
				} else {
					self.selectedSubproducts.push(productId);
				}
			}
		},
		watch: {
			selectedSubproducts() {
				const self = this;
				self.changeGroupProductSelection(self.group, self.selectedSubproducts);
			}
		}
	};
</script>
